import { render, staticRenderFns } from "./ValueBlock.vue?vue&type=template&id=92a3a42c&scoped=true"
import script from "./ValueBlock.vue?vue&type=script&lang=js"
export * from "./ValueBlock.vue?vue&type=script&lang=js"
import style0 from "./ValueBlock.vue?vue&type=style&index=0&id=92a3a42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a3a42c",
  null
  
)

export default component.exports